// @flow
import React, { Fragment } from 'react';
import { MdSearch, MdPrint } from 'react-icons/lib/md';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import Select from '../Select';
import Input from '../Input';
import Button from '../Button';
import styles from './usersFilters.css';
import * as userActions from '../../actions/users';


type UsersFiltersPropTypes = {
  changeFilters: Function
};

const UsersFilters = ({
  changeFilters,
}: UsersFiltersPropTypes) => {
  const profileTypes = [
    {
      value: 'all',
      label: i18n.t('common.all'),
    },
    {
      value: 'monitor',
      label: i18n.t('labels.monitor', { count: 2 }),
    },
    {
      value: 'student',
      label: i18n.t('labels.students', { count: 2 }),
    },
    {
      value: 'parent',
      label: i18n.t('labels.parent', { count: 2 }),
    },
  ];
  return (
    <Fragment>
      <div className={styles.row}>
        <div className={styles.leftGroup}>
          <Input
            placeholder={i18n.t('common.search')}
            size="medium"
            Icon={MdSearch}
            iconPosition="right"
            onChange={
            ({ target }) => changeFilters('text', target.value)
          }
          />
        </div>
        <div className={styles.rightGroup}>
          <div className={styles.selectContainer}>
            <Select
              options={profileTypes}
              onChange={
              value => changeFilters('result_type', value)
            }
            />
          </div>
          <Button
            isOutlined
            clearMargins
            isTransparent
            size="medium"
            Icon={MdPrint}
            tint="mediumGray"
            iconPosition="right"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default connect(
  undefined,
  dispatch => ({
    changeFilters(key: string, filter: string) {
      dispatch(userActions.changeUserFilters(key, filter));
      dispatch(userActions.startFetchingUsers(1));
    },
  }),
)(UsersFilters);



// WEBPACK FOOTER //
// ./src/scripts/components/UsersFilters/index.jsx